import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Mixin from 'components/common/Mixin'
import Media from 'components/common/Media'
import { H1 } from 'components/common/Text/Text'
import Button from 'components/common/Button/Button'
import { expandQuickAppointmentButton } from 'helpers/custom-events'

const AppointmantHeader = ({ title, ...props }) =>
  <TitleWrapper { ...props }>
    <Title data-at-myaccount-appointmentheader headline inline>{ title }</Title>
    <AppointmentButton data-at-myaccount-makeanappointment full="mobile" onClick={ expandQuickAppointmentButton }>
      Request Appointment
    </AppointmentButton>
  </TitleWrapper>

AppointmantHeader.propTypes = {
  title: PropTypes.string
}

export default AppointmantHeader

const TitleWrapper = styled.div`
  ${Media.mobile`
    padding-bottom: 20px;
  `}
  ${Mixin.clearFix()}
`

const Title = styled(H1)`
  ${Media.desktop`
    vertical-align: top;
  `}
  ${Media.mobile`
    font-size: 20px;
    line-height: 43px;
  `}
  ${Mixin.responsive('margin', '0 0 32px', '0 0 18px')}
`

const AppointmentButton = styled(Button)`
  ${Media.desktop`
    float: right;
  `}
`
